import React, { useState } from 'react';

export default function FormSettings({ formSettings, updateFormSettings }) {
  const handleChange = (field, value) => {
    updateFormSettings({
      ...formSettings,
      [field]: value,
    });
  };

  return (
    <div className="w-64 p-2 border bg-white rounded">
      <h2 className="font-semibold mb-2">Form Settings</h2>
      <div className="space-y-2">
        <label className="block">
          <span className="text-sm font-medium">Title:</span>
          <input
            className="w-full border p-1 text-sm"
            value={formSettings.title}
            onChange={e => handleChange('title', e.target.value)}
          />
        </label>
        <div className="grid grid-cols-2 gap-2">
          <label className="block">
            <span className="text-sm font-medium">Width:</span>
            <input
              className="w-full border p-1 text-sm"
              type="number"
              value={formSettings.width}
              onChange={e => handleChange('width', parseInt(e.target.value) || 800)}
            />
          </label>
          <label className="block">
            <span className="text-sm font-medium">Height:</span>
            <input
              className="w-full border p-1 text-sm"
              type="number"
              value={formSettings.height}
              onChange={e => handleChange('height', parseInt(e.target.value) || 600)}
            />
          </label>
        </div>
        <label className="block">
          <span className="text-sm font-medium">Background Color:</span>
          <select
            className="w-full border p-1 text-sm"
            value={formSettings.backgroundColor}
            onChange={e => handleChange('backgroundColor', e.target.value)}
          >
            <option value="White">White</option>
            <option value="LightGray">Light Gray</option>
            <option value="LightBlue">Light Blue</option>
            <option value="LightGreen">Light Green</option>
            <option value="Transparent">Transparent</option>
          </select>
        </label>
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            id="resizable"
            checked={formSettings.resizable}
            onChange={e => handleChange('resizable', e.target.checked)}
            className="w-4 h-4"
          />
          <label htmlFor="resizable" className="text-sm font-medium">
            Resizable Window
          </label>
        </div>
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            id="maximizable"
            checked={formSettings.maximizable}
            onChange={e => handleChange('maximizable', e.target.checked)}
            className="w-4 h-4"
          />
          <label htmlFor="maximizable" className="text-sm font-medium">
            Maximizable Window
          </label>
        </div>
        <label className="block">
          <span className="text-sm font-medium">Window Location:</span>
          <select
            className="w-full border p-1 text-sm"
            value={formSettings.windowStartupLocation || 'CenterScreen'}
            onChange={e => handleChange('windowStartupLocation', e.target.value)}
          >
            <option value="CenterScreen">Center Screen</option>
            <option value="CenterOwner">Center Owner</option>
            <option value="Manual">Manual</option>
          </select>
        </label>
      </div>
    </div>
  );
}
